 export class KitchenModel {
        kitchenUid: string;

        shopNumber: number;

        name: string;

        ipaddress: string;

        defaultTrainName: string;

        defaultTrainUID: string;

        defaultPeak?: number;

        defaultPeakName: string;

        eetRegNumber: number;

        active = true;

        kitchenTypeName: string;

        kitchenType: string;

        trains: any;

        peaks: any;

        dataReady: boolean;
    }



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/kitchen-list/kitchen.model.ts